export const LOCATION_DETAILS_PATH = "/locationDetails";
export const HOME_PATH = "/home";
export const ABOUT_PATH = "/about";
export const UNAUTHORIZED_PATH = "/401";
export const PAGE_NOT_FOUND_PATH = "/404";
export const DASHBOARD_PATH = "/dashboard";
export const CHECKOUT_PATH = "/checkout";
export const PROFILE_PATH = "/profile";
export const TOAST_HEADING_SUCCESS = "Success";
export const TOAST_HEADING_ERROR = "Error";
export const AXIOS_DEFAULT_TIMEOUT = 60000;
export const SCHEDULE_TYPES = [{
        name: "ASAP",
        value: "asap",
    },
    {
        name: "Custom Pickup",
        value: "custom",
    },
];

export const HOME_PAGE_PRODUT_INITIAL_PAGE = 1;

export const HOME_PAGE_PRODUCTS_INITIAL_LIMIT = 15;

export const LOGIN_REQUIRED_TO_SAVE_DELIVERY_ADDRESS =
    "Sign in to save your delivery address for faster checkout.";

export const PLEASE_ENTER_A_VALID_DELIVERY_ADDRESS =
    "Delivery address is required.";

export const GET_USER_DELIVERY_ADDRESSES_API_ROUTE =
    "/api/v1/user-delivery-addresses";

export const SAVE_DELIVERY_ADDRESS_FOR_FUTURE_ORDER_API_ROUTE =
    "/api/v1/save-delivery-address";

export const DB_NAME = "octopos.db";

export const COUPON_ALREADY_APPLIED = "This coupon has already been used."; //TODO Rakesh

export const COUPON_PRODUCT_ELIGIBLE_ORDER_AMOUNT_LESS =
    "Applying this coupon reduces the minimum order total."; //TODO Rakesh

export const MANUAL_DISCOUNT_ALREADY_APPLIED = "discount is already applied."; //TODO Rakesh

export const COUPON_MAX_USAGE = "This coupon can't be used anymore"; //TODO Rakesh

export const ORDER_MINIMUM_AMOUNT_LESS_PRODUCT_ELIGIBLE_CHECK =
    "Order total is below coupon minimum."; //TODO Rakesh

export const ORDER_MINIMUM_AMOUNT_LESS = "Order total is below coupon minimum."; //TODO Rakesh

export const ENTER_VALID_PHONE_NUMBER = "Enter a valid phone number."; //TODO Rakesh

export const REWARD_REDEEMED = "REWARD REDEEMED."; //TODO Rakesh

export const TOFIXED5 = 100000;

export const COUPON_APPLIED = "COUPON APPLIED"; //TODO Rakesh

export const NONE_MODIFIER = {
    name: "None",
    price: 0,
    server_id: -1,
    sort: 0
};
export const MODIFIER_UPDATE_ERROR =
    "Sorry, You can not update this item as discount is applied in this product or order. Please remove it and try again."; //TODO Rakesh
export const SERVER_NOT_AVAILABLE =
    "Looks like server is offline. Please contact to system administrator."; //TODO Rakesh
export const HALF_PAYMENT =
    "Sorry, the payment process has already started. Please complete it first.";
export const Quantity_UPDATE_ERROR =
    "Sorry, You can not update this item's Qty as discount is applied in this product or order. Please remove it and try again."; //TODO Rakesh
export const BACKEND_ERROR = "Error: Network Error";
export const PAYMENT = "Payment";
export const LOGOUT = "Logout";
export const TIPS_AMOUNT = "Tips Amount";
export const ADD_REWARD_SUCCESSFULL = "Your reward card has been successfully added to your order.";
export const REWARD_COUPON = "RewardCoupon";
export const CANT_ADD_QUANTITY_999999 =
    "You can not add quantity more than 999999.";
export const CANT_ADD_QUANTITY_999999_99 =
    "You can not add quantity more than 999999.99.";
export const MINIMUM_ORDER_AMT_MUSTBE =
    "Sorry, you can not remove this item as minimum order amount must be "; //TODO Rakesh
export const MINIMUM_ORDER_AMT_MUSTBE_0ORMORE =
    "Sorry, you can not remove this item as minimum order amount must be 0 or more."; //TODO Rakesh
export const MINIMUM_ORDER_AMT_DISCOUNT =
    "Sorry, you can not apply discount on this item as minimum order amount must be "; //TODO Rakesh
export const DISCOUNT_MUST_BE_LESS = "Discount amount must be less or equal to"; //TODO Rakesh
export const DISCOUNT_MUST_BE_LESS$ =
    "Discount amount must be less or equal to $"; //TODO Rakesh
export const ORDER_DICOUNT_100 =
    "Sorry, order discount is apply 100%, so you can not add product discount."; //TODO Rakesh
export const CANT_REMOVE_ITEM =
    "Sorry, you can not remove this item as minimum order amount must be 0 or more."; //TODO Rakesh

// OCTO GRUB CONSTANT
//    *******************    delivery details start   ****************************
export const URL =
    window.location.protocol + "//" + window.location.hostname + ":8000";
export const BACKEND_ERROR_CODE = "Error: Request failed with status code 404";
export const ERROR = "error";
export const DELIVERY_TIME_SELECT_ERROR = "Delivery time is required.";
export const PICKUP_TIME_SELECT_ERROR = "Pickup time is required.";
export const PICKUP_LOCATION_NOT_FOUND = "Enter a valid pickup location.";
export const PICKUP_TIME_SLOTE_NOT_FOUND = "Sorry, no time slots are available for today.";
export const DAY_CHANGE_TIME_SLOTE_NOT_AVAILABLE =
    "Sorry, no time slots are available for today."; // Today's time slot is unavailable.
export const DELIVERY_LOCATIONS_NOT_AVAILABLE =
    "We’re sorry, but delivery is not available in any location right now.";
export const ENTER_DELIVERY_ADDRESS_ZIPCODE_NOT_AVAILABLE =
    "Sorry, we don't deliver to your area. We serve these zip codes: ";
export const DELIVERY_TIME_SLOTE_NOT_FOUND =
    "Sorry, no time slots are available for today."; //No delivery time slots are available.
export const DELIVERY_ADDRESS_LOCATION_NOT_FOUND =
    "Sorry, we don't deliver to your area. We serve these zip codes: "; //todo delivery not available for selected address
export const DELIVERY_ADDRESS_ZIPCODES_NOT_FOUND =
    "We’re not delivering to any locations at the moment. Apologies!"; //todo delivery not available for selected address
export const DELIVERY_ADDRESS_NOT_FOUND =
    "Invalid address. Please try again."; //Enter Delivery address not found.
export const DELIVERY_ADDRESS_ZIPCODE_NOT_FOUND =
    "Zip code required. Please try again."; //Enter Delivery address zipcode not found.
export const DELIVERY_ADDRESS_COUNTRY_NOT_FOUND =
    "Country required. Please try again."; //Your selected address country not available.
export const DELIVERY_ADDRESS_STATE_NOT_FOUND =
    "State required. Please try again."; //Your selected address state not available.
export const DELIVERY_ADDRESS_CITY_NOT_FOUND =
    "City required. Please try again."; //Your selected address city not available.
export const STORE_OPEN_BEFORE_ORDER_START =
    "We're not open for delivery and pickup yet. Please visit us later today.";
export const STORE_CLOSE_AFTER_ORDER_START =
    "Sorry, we’re closed for delivery and pickup today. We’ll be happy to serve you tomorrow!";
export const SERVER_ERROR =
    "We're having trouble connecting right now. Please try again in a moment.";
export const FORGOT_PASSWORD_SUCCESS =
    "We've emailed you a link to reset your password!";
export const OTP_SENT_TO_MOBILE_NUMBER =
    "An OTP has been sent to your mobile number.";
export const OTP_REQUIRED = "Enter an OTP.";
export const LOGOUT_SUCCESS = "You have successfully logged out.";
//    *******************    delivery details End   ****************************
//    *******************    Create User,SIGNIN,FORGOT PASSWORD,PASSWORD RESET ***************************************
export const USER_ENTER_ADDRESS_ZIPCODE_NOT_FOUND =
    "The zipcode is missing from the address you entered. Please try again.";
export const USER_ENTER_ADDRESS_COUNTRY_NOT_FOUND =
    "The country is missing from the address you entered. Please try again.";
export const USER_ENTER_ADDRESS_STATE_NOT_FOUND =
    "The state is missing from the address you entered. Please try again.";
export const USER_ENTER_ADDRESS_CITY_NOT_FOUND =
    "The city is missing from the address you entered. Please try again.";
export const USER_ENTER_ADDRESS_NOT_FOUND = "Enter a valid address.";
export const USER_FIRST_NAME_REQUIRED = "First name is required.";
export const USER_FIRST_NAME_LENGTH_GREATE_THEN_255 =
    "First name must be less than 255 characters long.";
export const USER_LAST_NAME_REQUIRED = "Last name is required.";
export const VALID_LAST_NAME = "Enter a valid last name";
export const VALID_FIRST_NAME = "Enter a valid first name ";
export const USER_LAST_NAME_LENGTH_GREATE_THEN_255 =
    "Last name must be less than 255 characters long.";
export const ENTER_VALID_ORDER_INSTRUCTION = "Enter valid order instruction.";
export const USER_EMAIL_REQUIRED = "Email is required.";
export const USER_EMAIL_NOT_VALID = "Enter a valid email.";
export const USER_EMAIL_LESS_THEN_OR_EQUAL_255_CHARACTER =
    "Email cannot be more than 255 characters long.";
export const USER_PHONE_NUMBER_REQUIRED = "Phone Number is required.";
export const USER_PHONE_NUMBER__NOT_VALID = "Enter a valid phone number.";
export const USER_PHONE_NUMBER_GREATER_THEN_10 =
    "Phone numbers must be 10 digits or less.";
export const USER_PHONE_NUMBER_MUST_BE_3_DIGITS =
    "Phone numbers must be at least 3 digits long.";
export const PASSWORD_FIELD_REQUIRED = "Password is required.";
export const PASSWORD_MUST_BE_8_CHARACHTER =
    "Password must be at least 8 characters long.";
export const CONFIRM_PASSWORD_FIELD_REQUIRED = "Confirm password is required.";
export const CONFIRM_PASSWORD_MUST_BE_8_CHARACHTER =
    "Confirm password must be at least 8 characters long.";
export const PASSWORD_CONFIRM_PASSWORD_NOT_SAME =
    "Password and confirm password must match.";
export const USER_ADDRESS_REQUIRED = "Address is required.";
//    ************************ Create User,SIGNIN,FORGOT PASSWORD,PASSWORD RESET END
export const SIGNIN_ROUTE = "/sign-in";
export const SIGNUP_PATH = "/sign-up";
export const Products = "Products";
export const RESET_PASSWORD_PATH = "/reset/:key";
export const CATEGORY_PATH = "/category";
export const PRODUCT_PATH = "/category/:categoryId";
export const FLAGE = "flag";
export const DATA = "data";
export const POST = "post";
export const GET = "get";
export const REQUEST_DENIED_CODE = 999;
export const SIGNIN_PATH = "/";
export const LOGIN_PATH = "/login";
export const TOAST_HEADING_WARNING = "Warning";
// Api Code
export const UNAUTHORIZE_CODE = 401;
export const FORBIDDEN_ERROR = 403;
export const NOT_FOUND_ERROR = 404;
export const UNAUTHORIZE_PAGE = "/401";
export const FORBIDDEN_ERROR_PAGE = "/403";
export const TOKEN_EXPIRTED = "Session Timed Out.";
//     *********************** My Bag start   ********************
export const VALID_SPECIAL_INSTRUCTION =
    "Special instructions must be 255 characters or less.";
//     *********************** My Bag end   ********************
//     *********************** Delivery-Pickup inside file   ********************
export const ORDER_BALANCE_ZERO =
    "Your order total is $0.00. You cannot proceed with checkout.";
//    ***********************  User Card Details  *************************
export const CVC_REQUIRED = "CVC is required.";
export const VALID_CVC = "CVC is invalid.";
export const EXPIRY_DATE_REQUIRED = "Expiry date is required.";
export const VALID_EXPIRY_DATE = "Expiry date is invalid.";
export const PAST_EXPIRY_DATE = "Expiry date cannot be in the past.";
export const CARD_NUMBER_REQUIRED = "Card number is required.";
export const VALID_CARD_NUMBER = "Card number is invalid.";
export const CARD_NAME_REQUIRED = "Card Holder Name is required.";
export const VALID_CARD_NAME = "Card Holder Name must be under 255 characters.";
export const VALID_ORDER_INSTRUCTION =
    "Order instructions cannot exceed 255 characters.";
//   ************************  check out page start *********************************
export const VALID_TIPAMOUNT = "Enter a valid tip amount.";
export const TIPS_AMOUNT_VALIDATION =
    "Enter a tip amount between $0.01 and $99,999.";
export const ENTER_TIPAMOUNT = "Tip amount is required.";
export const CHECKOUT_PAGE_USER_LOGOUT = "Please log in to continue.";
export const CHECKOUT_PAGE_ADDRESS_NOT_FOUND =
    "We couldn't find your delivery or pickup location details.";
export const USER_CARD_DETAILS_NOT_FOUND = "Enter your payment card details.";
export const SELECTE_TIME_SLOTE_IS_BEFORE_CURRUNT_TIME =
    "The time slot you selected has passed. Please choose a new time slot if available.";
export const NO_SLOTES = "It seems there are no time slots available today.";
export const REWARD_CARD_PHONE_NOT_VALID = "Enter a valid reward card number.";
export const REWARD_CARD_PHONE_IS_REQUIRED = "Reward card number is required.";
export const REWARD_CARD_PHONE_MIN_VALUE =
    "Reward card number must be at least 3 digits long.";
export const REWARD_CARD_PHONE_MAX_VALUE =
    "Reward card number cannot be more than 10 digits long.";
export const GET_REWARD_CARD_API_ROUTE = "/api/v1/rewardcard";
export const TOAST_HEADING_REWARD_CARD = "Reward Card";
export const DELETE_USER_CARD_DETAIL_API_ROUTE =
    "/api/v1/delete-user-card-detail";
export const CANNOT_DELETE_DEFAULT_CARD = "Default card cannot be deleted.";
export const PAYMENT_DETAILS_HEADER = "Payment Details";
export const PAYMENT_DETAILS_DESCRIPTION =
    "Complete your purchase item by providing your payment details order.";
export const PICKUP_TIME_SLOT_ERROR =
    "Select an available Time Slot.";
export const MINIMUM_ORDER_AMOUNT_FOR_DELIVERY =
    "Minimum order amount for Delivery is $";
export const GIFT_CARD_BALANCE_ZERO = "This gift card has no remaining balance.";
export const PAYMENT_PROCESSING = "Payment Processing";
export const PAYMENT_PROCESSING_DESCRIPTION = "Please wait while your payment is being processed.";
export const PAYMENT_PROCESSING_WARNING = "Please do not refresh or close the page while payment is being processed.";
// ---------------------  User Card Details  ---------------------
export const GET_USER_CARD_DETAILS_API_ROUTE = "/api/v1/user-card-details";
//   -------------------------   gift card page start   ---------------------------------
export const GIFT_CARD_TOAST_HEADING = "Gift Card";
export const GIFT_CARD_AMOUNT_REQUIRED = "Select or enter an amount.";
export const GIFT_CARD_EMAIL_PHONE_REQUIRED = "Provide either email or phone number.";
export const GIFT_CARD_ADD_SUCCESS = "Gift card added successfully.";
export const GIFT_CARD_AMOUNT_REQUIRED_ERROR = "Amount must be between $0.01 to $500.00.";
export const GET_GIFT_CARD_CURRENT_BALANCE_API_ROUTE =
    "/api/v1/get-gift-card-current-balance";
export const GIFT_CARD_CODE_REQUIRED = "Gift card code is required.";
export const USER_GIFTCARD__NOT_VALID = "Enter a valid gift card code.";
export const VALID_GIFT_CARD_AMOUNT = "Enter a valid amount.";
export const VALID_GIFT_CARD_AMOUNT_LESS_OR_GREATER =
    "The amount must be between $0.01 and $500.00.";
export const VALID_GIFT_CARD_CODE_LESS_OR_GREATER =
    "Gift Card code must be 4 to 24 digits long.";
export const GIFT_CARD_INSTRUCTION =
    "Gift Card message must be under 255 characters.";
export const BUY_GIFT_CARD_SUCCESS = "Gift card purchased successfully.";
export const TOAST_POSITION = "top-right";
export const TOAST_TYPE_SUCESS = "success";
export const TOAST_TYPE_WARNING = "warning";
export const TOAST_TYPE_ERROR = "error";
export const FIELD_IS_REQUIRED = "Field is required.";
export const TOAST_HEADING_SYSTEM_ERROR = "System Error";
export const SERVER_IS_NOT_REACHABLE =
    "Operation failed due to server unavailability.";
export const CONTANT_TYPE = "application/json";
export const DEACTIVE_TITLE = "Clear All";
export const DEACTIVE_DISCRIPTION = "Do you want to clear all items?";
export const CLEAR_ORDER_TITLE = "Clear Cart & Restart";
export const CLEAR_ORDER_DISCRIPTION = "Are you sure you want to empty your cart and restart your order?";
export const RESTART_ORDER = "Restart Order";
export const RESTART_ORDER_DISCRIPTION = "Are you sure you want to clear everything and restart your order?";
export const USER_LOGING = "User Loging";
export const USER_SIGNUP = "User SignUp";
export const PRODUCT_ADDED_SUCCESS = "is added successfully.";
export const RESET_PASSWORD = "Reset Password";
export const FORGOT_PASSWORD = "Forgot Password";
export const RESET_PASSWORD_URL = "/reset/";
//  ====================  Order History Module Constants ====================
export const ORDER_HISTORY_TOAST_HEADING = "Order History";
export const ORDER_HISTORY_PATH = "/order-history";
export const GET_USER_ONLINE_ORDER_HISTORY_API_ROUTE =
    "/api/v1/get-user-online-order-history";
export const GET_PROD_DETAILS_FOR_REPEAT_ORDER_API_ROUTE =
    "/api/v1/get-prod-details-for-reorder";
export const NOT_FOUND_ERROR_PAGE = "/404";
export const GENERATE_ORDER_PDF_API_ROUTE = "/api/v1/generate-order-pdf";
export const GIFT_CARD_PAYMENT_STARTED = "Finish your current payment.";
export const CARD_ERROR_MESSAGE =
    "This card is Already Saved.";
export const COUNTRY_CODES = [{
        code: "+1",
        country: "US",
        label: "+1 (US)"
    },
    // { code: '+44', country: 'UK', label: '+44 (UK)' },
    // { code: '+91', country: 'IN', label: '+91 (IN)' },
    // { code: '+1', country: 'CA', label: '+1 (CA)' },
];
export const API_LOG_TOO_MANY_ATTEMPTS_CODE = 429;
export const API_LOG_OTP_EXPIRED_CODE = 410;

export const USER_FORGOT_PASSWORD_SUCCESS =
    "We have sent you an Email to Forgot your password!";

export const DELIVERY_ADDRESS_REQUIRED = "Delivery address is required.";

export const SELECT_DELIVERY_ADDRESS = "Select any one delivery address";

// Email validation regex
// This pattern checks for:
// - One or more characters that aren't whitespace or @ before the @ symbol
// - One or more characters that aren't whitespace or @ after the @ symbol
// - A dot followed by 2-6 characters at the end
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const PRODUCT_NOT_FOUND = "No Product Found";

export const PRODUCT_NOT_FOUND_DESCRIPTION = "Please try again with different search criteria";

export const DELIVERY_SERVICE_NOT_AVAILABLE_LOCATION = "Delivery service is not supported at this location.";

export const OUT_OF_DELIVERY_AREA = "Sorry this address is out of the delivery area for this store.";

export const TIMEOUT_DELAY = 1000;

export const STORE_CLOSED = "Oops! We’re closed right now, but we’ll be open again tomorrow. See you then!";

export const REMOVE_ADDRESS_TITLE = "Remove Address";
export const REMOVE_ADDRESS_DESCRIPTION = "Are you sure you want to romove this address?";

export const UPDATE_PERSONAL_INFO_API_ROUTE =
    "/api/v1/update-personal-info";

export const UPDATE_USER_PASSWORD_API_ROUTE =
    "/api/v1/update-user-password";

export const UPDATE_PHONE_NUMBER_API_ROUTE =
    "/api/v1/update-phone-number";

export const DELETE_ADDRESS_API_ROUTE =
    "/api/v1/delete-user-address";

export const UPDATE_ADDRESS_API_ROUTE =
    "/api/v1/update-user-address";

export const ADDRESS_CREATED_SUCCESS = "Address created successfully.";

export const DELIVERY_ADDRESS_ALL_READY_EXISTS = "Delivery address is already exists.";